export const SUPPLIER_TYPES_IMPORT_FROM_FILE = 'importFromFile';
export const SUPPLIER_TYPES_IMPORT_FROM_API = 'importFromApi';

export const SUPPLIER_TYPE_EXAMPLE_INTEGRATION = 'exampleIntegration';
export const SUPPLIER_TYPE_INTERNAL = '_internal';
export const SUPPLIER_TYPE_AUTOEURO = 'autoEuro';
export const SUPPLIER_TYPE_AUTOIMPORT = 'autoImport';
export const SUPPLIER_TYPE_AUTOLAND = 'autoLand';
export const SUPPLIER_TYPE_AUTOPARTNERSA = 'autoPartnerSa';
export const SUPPLIER_TYPE_AUTOPARTNERHOLDING = 'autoPartnerHolding';
export const SUPPLIER_TYPE_AUTOS = 'autos';
export const SUPPLIER_TYPE_CAREX = 'carex';
export const SUPPLIER_TYPE_SAMLI = 'samli';
export const SUPPLIER_TYPE_JARO_FILTR = 'jaroFiltr';
export const SUPPLIER_TYPE_MMOT = 'mmot';
export const SUPPLIER_TYPE_AUTOZATOKA = 'autoZatoka';
export const SUPPLIER_TYPE_DARMA = 'darma';
export const SUPPLIER_TYPE_MOTORES = 'motores';
export const SUPPLIER_TYPE_ELIT = 'elit';
export const SUPPLIER_TYPE_GORDON = 'gordon';
export const SUPPLIER_TYPE_HANDLOPEX = 'handlopex';
export const SUPPLIER_TYPE_HOLMER = 'holmer';
export const SUPPLIER_TYPE_ROPA_POLSKA = 'ropaPolska';
export const SUPPLIER_TYPE_HART = 'hart';
export const SUPPLIER_TYPE_INTERCARS = 'interCars';
export const SUPPLIER_TYPE_INTERPARTS = 'interParts';
export const SUPPLIER_TYPE_INTERTEAM = 'interTeam';
export const SUPPLIER_TYPE_MOTOROL = 'motorol';
export const SUPPLIER_TYPE_PROFIAUTO = 'profiAuto';
export const SUPPLIER_TYPE_CERMOTOR = 'cerMotor';
export const SUPPLIER_TYPE_MARTEX = 'martex';
export const SUPPLIER_TYPE_AUTO_EXPRESS = 'autoExpress';
export const SUPPLIER_TYPE_ALCAR24 = 'alcar24';
export const SUPPLIER_TYPE_MYTNIK = 'mytnik';
export const SUPPLIER_TYPE_SKOPOL = 'skopol';
export const SUPPLIER_TYPE_TIPTOPOL = 'tipTopol';
export const SUPPLIER_TYPE_STACHMOT = 'stachmot';
export const SUPPLIER_TYPE_PARKER = 'parker';
export const SUPPLIER_TYPE_VANKING = 'vanKing';
export const SUPPLIER_TYPE_RK_NIEDZIALEK = 'rkNiedzialek';
export const SUPPLIER_TYPE_DUO_TRUCK = 'duoTruck';
export const SUPPLIER_TYPE_AGRO_EFEKT = 'agroEfekt';
export const SUPPLIER_TYPE_DOMINIK_JANICKI = 'dominikJanicki';
export const SUPPLIER_TYPE_RODON = 'rodon';
export const SUPPLIER_TYPE_MARCO_MARINE = 'marcoMarine';
export const SUPPLIER_TYPE_MADEJSKI = 'madejski';
export const SUPPLIER_TYPE_MP_AUTO = 'mpAuto';
export const SUPPLIER_TYPE_OPOLTRANS = 'opoltrans';
export const SUPPLIER_TYPE_SUDER = 'suder';
export const SUPPLIER_TYPE_AUTO_CZESCI_LIPIEC = 'autoCzesciLipiec';
export const SUPPLIER_TYPE_TM_PARTS = 'tmParts';
export const SUPPLIER_TYPE_X_TECH = 'xTech';
export const SUPPLIER_TYPE_OPONEO = 'oponeo';
export const SUPPLIER_TYPE_BMW_SMORAWINSKI = 'bmwSmorawinski';
export const SUPPLIER_TYPE_BMW_DOBRZANSKI = 'bmwDobrzanski';
export const SUPPLIER_TYPE_JADAR_AUTO = 'jadarAuto';
export const SUPPLIER_TYPE_ABAK_MOTO = 'abakMoto';
export const SUPPLIER_TYPE_AUTOMAT_CENTRUM_PL = 'automatCentrumPl';
export const SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA = 'motoArtWloszczowa';
export const SUPPLIER_TYPE_MOTO_ART_KIELCE = 'motoArtKielce';
export const SUPPLIER_TYPE_MERCEDES_BENZ_COM = 'mercedesBenzCom';
export const SUPPLIER_TYPE_BSL = 'bsl';
export const SUPPLIER_TYPE_SIEMIENIEC = 'siemieniec';
export const SUPPLIER_TYPE_MOTOGAMA = 'motogama';
export const SUPPLIER_TYPE_KTD = 'ktd';
export const SUPPLIER_TYPE_POLAMEL = 'polamel';
export const SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN = 'tdAutoKedzierzyn';
export const SUPPLIER_TYPE_TD_AUTO_OPOLE = 'tdAutoOpole';
export const SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ = 'autoCentrumMatusiewicz';
export const SUPPLIER_TYPE_ATV_EXPERT = 'atvExpert';
export const SUPPLIER_TYPE_OLEK_MOTOCYKLE = 'olekMotocykle';
export const SUPPLIER_TYPE_PRO_BIKES = 'proBikes';
export const SUPPLIER_TYPE_GO_WEST = 'goWest';
export const SUPPLIER_TYPE_AUTO_PARTS_100_AB = 'autoParts100Ab';
export const SUPPLIER_TYPE_SPEED_FACTORY = 'speedFactory';
export const SUPPLIER_TYPE_KAWASAKI_PRO_BIKE = 'kawasakiProBike';
export const SUPPLIER_TYPE_DAN_CAR = 'danCar';
export const SUPPLIER_TYPE_GRAFTON_DIRT_BIKE = 'graftonDirtBike';
export const SUPPLIER_TYPE_LATEX = 'latex';
export const SUPPLIER_TYPE_ARGE_KRAKOW = 'argeKrakow';
export const SUPPLIER_TYPE_ARGE_KROSNO = 'argeKrosno';
export const SUPPLIER_TYPE_AUTO_WOJDYLA = 'autoWojdyla'
export const SUPPLIER_TYPE_AUTO_PLUS = 'autoPlus'
export const SUPPLIER_TYPE_WAZ_CAR = 'wazCar'
export const SUPPLIER_TYPE_EXACT_POLAND = 'exactPoland'
export const SUPPLIER_TYPE_AFTER_MARKET = 'afterMarket'
export const SUPPLIER_TYPE_AUTO_MAR_TWARDOGORA = 'autoMarTwardogora'
export const SUPPLIER_TYPE_AUTO_MAR_TORUN = 'autoMarTorun'
export const SUPPLIER_TYPE_AUTO_GAMA = 'autoGama'
export const SUPPLIER_TYPE_PARTS_TEAM = 'partsTeam'
export const SUPPLIER_TYPE_EURO_PARTS = 'euroParts'
export const SUPPLIER_TYPE_EDPOL = 'edpol'
export const SUPPLIER_TYPE_DYNEX = 'dynex'
export const SUPPLIER_TYPE_ARIS_AUTO = 'arisAuto'
export const SUPPLIER_TYPE_TOMALA = 'tomala'
export const SUPPLIER_TYPE_AS_PL = 'asPl'
export const SUPPLIER_TYPE_AUTO_FORUM = 'autoForum'
export const SUPPLIER_TYPE_LARSSON = 'larsson'
export const SUPPLIER_TYPE_WILMAT = 'wilmat'
export const SUPPLIER_TYPE_PARTNER_OPONY = 'partnerOpony'
export const SUPPLIER_TYPE_AUTO_GROUP_POLSKA = 'autoGroupPolska'
export const SUPPLIER_TYPE_TEMOT = 'temot'
export const SUPPLIER_MOTO_MAX = 'motoMax'
